import { render, staticRenderFns } from "./RegLeishmaniasiAdd.vue?vue&type=template&id=10a1dd41"
import script from "./RegLeishmaniasiAdd.vue?vue&type=script&lang=js"
export * from "./RegLeishmaniasiAdd.vue?vue&type=script&lang=js"
import style0 from "./RegLeishmaniasiAdd.vue?vue&type=style&index=0&id=10a1dd41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports